import React from "react";
import { Switch, Redirect } from "react-router-dom";
import Login from "./common/components/Login/LoginContainer";
import { ResetPassword } from "./common/components/reset_password";
import SuccessLoginOauth from "./successLoginOauthPage";

import {
    // Home
    home,
    // Reservations
    reservations,

    // Reservations > Airline / Charter / Tours (legacy — retired, redirect to Odoo note)
    reservationsAirline,
    reservationsCharter,
    reservationsTours,

    // Reservations > Shuttles
    reservationsShuttles,
    reservationsShuttlesTracking,
    reservationsShuttlesTrackingId,
    reservationsShuttlesTrackingNew,

    // Reservations > Expense Tickets
    resrvationsExpenseTickets,

    // HR > Vendors
    hrVendors,
    hrVendorDetails,

    // Reports
    reports,

    // Reports > Revenue
    reportsRevenue,

    // Reports > Trip Report
    reportsTripReport,
    reportsTripReportId,
    hotelPickupReport,

    // Marketing
    marketing,

    // Marketing > Promo Codes
    marketingPromoCodes,
    marketingPromoCodesId,
    marketingPromoCodesNew,

    // Marketing > Blog posts
    marketingBlogPosts,
    marketingBlogPostsNew,
    marketingBlogPostsId,

    // Marketing > Helpful Links
    marketingHelpfulLinks,
    marketingHelpfulLinksNew,
    marketingHelpfulLinksId,

    //Hr > Applications
    hrApplications,
    hrApplicationsId,

    // Settings
    settings,

    // Settings > Tours
    settingsTours,
    settingsToursCreate,
    settingsToursId,

    // Settings > Accounts (Customers)
    settingsAccounts,
    settingsAccountsCompanies,
    settingsAccountsCompaniesId,
    settingsAccountsCustomers,
    settingsAccountsCustomersNew,
    settingsAccountsCustomersId,
    settingsAccountsPoints,
    settingsAccountsPointsId,

    // Settings > Rates
    settingsRates,
    settingsRatesLocations,
    settingsRatesLocationsCreate,
    settingsRatesLocationsId,
    settingsRatesLocationsIdUpdate,
    settingsRatesLocationsIdVehicles,
    settingsRatesLocationsIdZipCodes,
    settingsRatesLocationsIdPromotionalRates,
    settingsRatesLocationsIdPromotionalRatesSpecialRates,
    settingsRatesLocationsIdPromotionalRatesPointToPoint,
    settingsRatesLocationsIdPromotionalRatesPromoCodes,
    settingsRatesVehicles,
    settingsRatesVehiclesId,
    settingsRatesVehiclesNew,
    settingsRatesFees,
    settingsRatesFeesId,
    settingsRatesFeesNew,

    // Settings > Airline (Airline Crew)
    settingsAirlines,
    settingsAirlinesAccounts,
    settingsAirlinesAccountsId,
    settingsAirlinesAccountsIdRouteNew,
    settingsAirlinesAccountsIdRouteIdUpdate,
    settingsAirlinesAccountsIdRouteId,
    settingsAirlinesAccountsIdAccountGroupsNew,
    settingsAirlinesAccountsIdAccountGroupsId,
    settingsAirlinesZones,
    settingsAirlinesZonesId,
    settingsAirlinesZonesNew,
    settingsAirlinesAirports,
    settingsAirlinesContacts,
    settingsAirlinesLocations,
    settingsAirlinesOwners,

    // Settings > User Accounts
    settingsUserAccounts,
    settingsUserAccountsUsers,
    settingsUserAccountsUsersNew,
    settingsUserAccountsUsersId,
    settingsUserAccountsPermissions,
    settingsUserAccountsPermissionsNew,
    settingsUserAccountsPermissionsId,

    // Settings > Driver Schedules
    settingsDriverSchedules,
    settingsDriverSchedulesDailyShifts,
    settingsDriverSchedulesTimeOff,
    settingsDriverSchedulesSchedules,
    settingsDriverSchedulesDrivers,
    settingsDriverSchedulesForms,

    // No modified routes
    refundId,
    priceCheck,
    shuttlesId,
    liveryShuttles,
    liveryShuttlesCompany,
    airlineLivery,
    airlineLiveryDetails,
    login,
    passwordReset,
    passwordResetToken,
    successToken,
    odooFeatureRequestForm,
    hrNav,
} from "./routesConfiguration/paths";

// GroupRates
import {
    Grid as GRGRid,
    Create as GRCreate,
    Update as GRUpdate,
    Detail as GRDetail,
    VehiclesUpdate,
    ZipCodesUpdate,
    PromotionalRatesUpdate,
    SpecialRatesUpdate,
    PointToPointUpdate,
    PromoCodeUpdate,
} from "./common/components/GroupRates";
import {
    Grid as VHGrid,
    Create as VHCreate,
    Update as VHUpdate,
} from "./common/components/Vehicle";
import {
    Grid as USGrid,
    Create as USCreate,
    Update as USUpdate,
} from "./common/components/User";
import {
    Grid as CLGrid,
    Create as CLCreate,
    Update as CLUpdate,
} from "./common/components/Client";
import {
    ApplyGrid,
    ApplyDetail
} from "./common/components/apply";
import {
    Grid as PCGrid,
    Create as PCCreate,
    Update as PCUpdate,
} from "./common/components/PromoCode";
import {
    Grid as TRGrid,
    Create as TRCreate,
    Update as TRUpdate,
} from "./common/components/Tour";
import HotelTripReport from "./common/components/hotelTripsReport/HotelTripReport.js"
import TripSearch from "./common/components/hotelTripsReport/TripSearch.js";
import {
    Grid as TripsReportGrid,
    Detail as TripReportDetail,
} from "./common/components/TripsReport";
import {
    Grid as COMPGrid,
    Update as COMPUpdate,
} from "./common/components/Company";
import Revenue from "./common/components/Revenue";
import {
    Grid as ADCGrid,
    Create as ADCCreate,
    Update as ADCUpdate,
} from "./common/components/additionalCharges";

import ExpenseTickets from "./common/components/ExpenseTickets/ExpenseTickets.jsx";
import { HrMenu } from "./common/components/HrNav/index.js";
import CustomersNav from './common/components/customersNav';
import RatesNav from './common/components/ratesNav';
import UserAccountsNav from './common/components/userAccountsNav';
import ReservationsNav from "./common/components/reservationsNav";
import ReportsNav from "./common/components/reportsNav";
import MarketingNav from "./common/components/MarketingNav";
import SettingsNav from "./common/components/SettingsNav";
import LegacyReservationRedirect from "./common/components/LegacyReservationRedirect";

import {
    RefundList,
} from "./common/components/Refund";

import Privado from "./common/components/Privado/Privado";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";

import {
    Create as CreateBlogPost,
    Grid as BlogPostGrid,
    Update as BlogPostUpdate
} from "./common/components/BlogPost";

import {
    Create as HelpfulLinkCreate,
    Grid as HelfpfulLinksGrid,
    Update as HelpfulLinkUpdate
} from "./common/components/Marketing/HelpfulLinks";

// Crew admin
import {
    Grid as CrewAdmin,
    Update as UpdateCrewAdmin,
    Create as CreateCrewAdmin
} from './common/components/crewAdmin';
import {
    GridCompanies,
    DetailsCompanies
} from './common/components/crewAdmin/companies';
import {
    GridZones,
    CreateZones,
    UpdateZones,
} from './common/components/crewAdmin/zones';

import PriceCheck from './common/components/priceCheck';
import CrewAirports from './common/components/crewAdmin/airports';
import CrewContacts from './common/components/crewAdmin/contacts';
import CrewLocations from './common/components/crewAdmin/locations';
import CrewAccountOwner from './common/components/crewAdmin/account_owner';
import CreateAirlineRoute from './common/components/crewAdmin/companies/details/routes/create';
import UpdateAirlineRoute from './common/components/crewAdmin/companies/details/routes/update';
import ReadAirlineRoute from './common/components/crewAdmin/companies/details/routes/details';
import CreateAccountGroup from './common/components/crewAdmin/companies/details/accountGroups/create';
import UpdateAccountGroup from './common/components/crewAdmin/companies/details/accountGroups/update';

{/* Point details */ }
import {
    Grid as usersPoints,
    Details as pointsDetails,
} from './common/components/points';

// Roles
import {
    Grid as RolesGrid,
    Update as RolesUpdate,
    Create as RolesCreate
} from './common/components/roles';

import {
    Create as ErpIssueCreate
} from "./common/components/erp_issue";

// Shuttles
import ShuttleNav from './common/components/shuttleNav';
import {
    List as ShuttleList,
    Detail as ShuttleDetail,
    Create as ShuttleCreate,
    Update as ShuttleUpdate,
    LiveryShuttleCompanySelect,
    LiveryShuttle,
} from "./common/components/shuttles";

import "../assets/fonts/fonts.css";
import { DriverSchedule } from "./common/components/DriverSchedule/DriverSchedule.jsx";
import { DailyShifts } from "./common/components/DriverSchedule/nav/DailyShifts.jsx";
import { Schedules } from "./common/components/DriverSchedule/nav/Schedules.jsx";
import TimeOff from "./common/components/DriverSchedule/nav/TimeOff.jsx";
import { Drivers } from "./common/components/DriverSchedule/nav/Drivers.jsx"
import { FormsView } from "./common/components/DriverSchedule/nav/FormsView.jsx";
import { VendorManagementPage } from "./common/components/VendorManagement/Vendors/VendorManagementPage.jsx";
import { VendorDetails } from "./common/components/VendorManagement/VendorDetails/index.js";

require("../../node_modules/font-awesome/css/font-awesome.css");
require("../../node_modules/bootstrap/dist/css/bootstrap.css");
require("../style/index.css");

module.exports = (
    <div>
        <div className="container__content">
            <Switch>
                {/* Legacy booking systems retired — reservations are now made in Odoo */}
                <ProtectedRoute path={reservationsAirline} component={LegacyReservationRedirect} />
                <ProtectedRoute path={reservationsCharter} component={LegacyReservationRedirect} />
                <ProtectedRoute path={reservationsTours} component={LegacyReservationRedirect} />
                <Redirect
                    exact
                    from="/settings/airlines/accounts/:airlineId/route"
                    to="/settings/airlines/accounts/:airlineId"
                />

                <Redirect
                    exact
                    from="/settings/airlines/accounts/:airlineId/account-groups"
                    to="/settings/airlines/accounts/:airlineId"
                />

                <PublicRoute exact path={login} component={Login} />

                <ProtectedRoute exact path={settings} component={SettingsNav} />
                {/* GroupRates */}
                <ProtectedRoute path={settingsRatesLocationsCreate} component={GRCreate} />
                <ProtectedRoute path={settingsRatesLocationsIdUpdate} component={GRUpdate} />
                <ProtectedRoute exact path={settingsRatesLocations} component={GRGRid} />
                <ProtectedRoute exact path={settingsRatesLocationsId} component={GRDetail} />
                <ProtectedRoute exact path={settingsRatesLocationsIdVehicles} component={VehiclesUpdate} />
                <ProtectedRoute exact path={settingsRatesLocationsIdZipCodes} component={ZipCodesUpdate} />
                <ProtectedRoute exact path={settingsRatesLocationsIdPromotionalRates} component={PromotionalRatesUpdate} />
                <ProtectedRoute exact path={settingsRatesLocationsIdPromotionalRatesSpecialRates} component={SpecialRatesUpdate} />
                <ProtectedRoute exact path={settingsRatesLocationsIdPromotionalRatesPointToPoint} component={PointToPointUpdate} />
                <ProtectedRoute exact path={settingsRatesLocationsIdPromotionalRatesPromoCodes} component={PromoCodeUpdate} />

                <ProtectedRoute
                    exact
                    path={reservations}
                    component={ReservationsNav}
                />

                <ProtectedRoute
                    exact
                    path={hrNav}
                    component={HrMenu}
                />

                <ProtectedRoute
                    exact
                    path={resrvationsExpenseTickets}
                    component={ExpenseTickets}
                />

                <ProtectedRoute
                    exact
                    path={hrVendors}
                    component={VendorManagementPage}
                />

                <ProtectedRoute
                    exact
                    path={hrVendorDetails}
                    component={VendorDetails}
                />

                <ProtectedRoute path={settingsRatesVehiclesNew} component={VHCreate} />
                <ProtectedRoute
                    path={settingsRatesVehiclesId}
                    component={VHUpdate}
                />
                <ProtectedRoute path={settingsRatesVehicles} component={VHGrid} />

                <ProtectedRoute path={settingsUserAccountsUsersNew} component={USCreate} />
                <ProtectedRoute path={settingsUserAccountsUsersId} component={USUpdate} />
                <ProtectedRoute path={settingsUserAccountsUsers} component={USGrid} />

                <ProtectedRoute
                    exact
                    path={settingsAccountsCustomers}
                    component={CLGrid}
                />
                <ProtectedRoute
                    exact
                    path={settingsAccountsCustomersNew}
                    component={CLCreate}
                />
                <ProtectedRoute
                    exact
                    path={settingsAccountsCustomersId}
                    component={CLUpdate}
                />

                <ProtectedRoute exact path={settingsAccountsCompanies} component={COMPGrid} />
                <ProtectedRoute
                    exact
                    path={settingsAccountsCompaniesId}
                    component={COMPUpdate}
                />

                <ProtectedRoute
                    exact
                    path={settingsDriverSchedules}
                    component={DriverSchedule}
                />

                <ProtectedRoute
                    exact
                    path={settingsDriverSchedulesDailyShifts}
                    component={DailyShifts}
                />

                <ProtectedRoute
                    exact
                    path={settingsDriverSchedulesTimeOff}
                    component={TimeOff}
                    applyContainer={false}
                />

                <ProtectedRoute
                    exact
                    path={settingsDriverSchedulesSchedules}
                    component={Schedules}
                    applyContainer={false}
                />

                <ProtectedRoute
                    exact
                    path={settingsDriverSchedulesDrivers}
                    component={Drivers}
                    applyContainer={false}
                />

                <ProtectedRoute
                    exact
                    path={settingsDriverSchedulesForms}
                    component={FormsView}
                    applyContainer={false}
                />

                <ProtectedRoute
                    exact
                    path={marketing}
                    component={MarketingNav}
                />

                <ProtectedRoute
                    exact
                    path={hrApplications}
                    component={ApplyGrid}
                    applyContainer={false}
                />

                <ProtectedRoute
                    exact
                    path={hrApplicationsId}
                    component={ApplyDetail}
                />

                <ProtectedRoute
                    exact
                    path={marketingPromoCodes}
                    component={PCGrid}
                />
                <ProtectedRoute
                    exact
                    path={marketingPromoCodesNew}
                    component={PCCreate}
                />
                <ProtectedRoute
                    exact
                    path={marketingPromoCodesId}
                    component={PCUpdate}
                />

                <ProtectedRoute exact path={settingsTours} component={TRGrid} />
                <ProtectedRoute
                    exact
                    path={settingsToursCreate}
                    component={TRCreate}
                />
                <ProtectedRoute
                    exact
                    path={settingsToursId}
                    component={TRUpdate}
                />

                <ProtectedRoute exact path={reports} component={ReportsNav} />

                <ProtectedRoute
                    exact
                    path={reportsTripReport}
                    component={HotelTripReport}
                />
                <ProtectedRoute
                    exact
                    path={hotelPickupReport}
                    component={TripSearch}
                />
                <ProtectedRoute
                    exact
                    path={reportsTripReportId}
                    component={TripReportDetail}
                />

                <ProtectedRoute exact path={settingsAccounts} component={CustomersNav} />
                <ProtectedRoute exact path={settingsRates} component={RatesNav} />
                <ProtectedRoute exact path={settingsUserAccounts} component={UserAccountsNav} />

                <ProtectedRoute exact path={reportsRevenue} component={Revenue} />
                <ProtectedRoute exact path={marketingBlogPosts} component={BlogPostGrid} />
                <ProtectedRoute exact path={marketingBlogPostsNew} component={CreateBlogPost} />
                <ProtectedRoute exact path={marketingBlogPostsId} component={BlogPostUpdate} />

                <ProtectedRoute exact path={marketingHelpfulLinks} component={HelfpfulLinksGrid} />
                <ProtectedRoute exact path={marketingHelpfulLinksNew} component={HelpfulLinkCreate} />
                <ProtectedRoute exact path={marketingHelpfulLinksId} component={HelpfulLinkUpdate} />

                <ProtectedRoute exact path={refundId} component={RefundList} />
                <ProtectedRoute exact path={settingsRatesFees} component={ADCGrid} />
                <ProtectedRoute exact path={settingsRatesFeesNew} component={ADCCreate} />
                <ProtectedRoute exact path={settingsRatesFeesId} component={ADCUpdate} />

                {/* Tracker Shuttler */}
                <ProtectedRoute exact path={reservationsShuttles} component={ShuttleNav} />
                <ProtectedRoute exact path={liveryShuttles} component={LiveryShuttleCompanySelect} />
                <ProtectedRoute exact path={liveryShuttlesCompany} component={LiveryShuttle} />
                <ProtectedRoute exact path={reservationsShuttlesTracking} component={ShuttleList} />
                <ProtectedRoute exact path={shuttlesId} component={ShuttleDetail} />
                <ProtectedRoute exact path={reservationsShuttlesTrackingNew} component={ShuttleCreate} />
                <ProtectedRoute exact path={reservationsShuttlesTrackingId} component={ShuttleUpdate} />

                {/* Admin airline, airport and meeting procedure */}
                <ProtectedRoute exact path={priceCheck} component={PriceCheck} />
                <ProtectedRoute exact path={settingsAirlines} component={CrewAdmin} />
                <ProtectedRoute exact path={settingsAirlinesAccounts} component={GridCompanies} />
                <ProtectedRoute exact path={settingsAirlinesAccountsId} component={DetailsCompanies} applyContainer={false} />
                <ProtectedRoute exact path={settingsAirlinesZones} component={GridZones} />
                <ProtectedRoute exact path={settingsAirlinesZonesNew} component={CreateZones} />
                <ProtectedRoute exact path={settingsAirlinesZonesId} component={UpdateZones} />
                <ProtectedRoute exact path={settingsAirlinesAirports} component={CrewAirports} />
                <ProtectedRoute exact path={settingsAirlinesContacts} component={CrewContacts} />
                <ProtectedRoute exact path={settingsAirlinesLocations} component={CrewLocations} />
                <ProtectedRoute exact path={settingsAirlinesOwners} component={CrewAccountOwner} />
                <ProtectedRoute exact path={settingsAirlinesAccountsIdRouteNew} component={CreateAirlineRoute} />
                <ProtectedRoute exact path={settingsAirlinesAccountsIdRouteIdUpdate} component={UpdateAirlineRoute} />
                <ProtectedRoute exact path={settingsAirlinesAccountsIdRouteId} component={ReadAirlineRoute} />
                <ProtectedRoute exact path={settingsAirlinesAccountsIdAccountGroupsNew} component={CreateAccountGroup} />
                <ProtectedRoute exact path={settingsAirlinesAccountsIdAccountGroupsId} component={UpdateAccountGroup} />

                {/* Point Details */}
                <ProtectedRoute exact path={settingsAccountsPoints} component={usersPoints} />
                <ProtectedRoute exact path={settingsAccountsPointsId} component={pointsDetails} />

                {/* Roles */}
                <ProtectedRoute exact path={settingsUserAccountsPermissions} component={RolesGrid} />
                <ProtectedRoute exact path={settingsUserAccountsPermissionsNew} component={RolesCreate} />
                <ProtectedRoute exact path={settingsUserAccountsPermissionsId} component={RolesUpdate} />

                {/* Odoo */}
                <ProtectedRoute exact path={odooFeatureRequestForm} component={ErpIssueCreate} />

                <PublicRoute exact path={passwordReset} component={ResetPassword} />
                <PublicRoute exact path={passwordResetToken} component={ResetPassword} />

                <PublicRoute exact path={successToken} component={SuccessLoginOauth} />
                <ProtectedRoute path={home} component={Privado} />
            </Switch>
        </div>
    </div>
);
